import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Moon } from 'lucide-react';

const MoonPhaseCalendar = ({ moonData }) => {
  return (
    <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700 animate-on-scroll card-hover hover-lift">
      <h3 className="font-semibold text-lg mb-4 dark:text-gray-100">🌙 Moon Phases This Week</h3>
      <div className="space-y-2">
        {moonData?.week && moonData.week.map((day, idx) => (
          <div key={idx} className="flex items-center justify-between p-3 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-600 rounded-lg">
            <div className="flex items-center gap-3">
              <span className="text-2xl">{day.phase.emoji}</span>
              <div>
                <p className="font-semibold dark:text-gray-100">{day.date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}</p>
                <p className="text-sm text-gray-600 dark:text-gray-400">{day.phase.name}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-600 dark:text-gray-400">{day.phase.illumination}% lit</p>
              <p className="text-xs text-gray-500 dark:text-gray-500">↑{day.moonrise} ↓{day.moonset}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-4 p-3 bg-purple-100 dark:bg-purple-900/20 rounded-lg border border-purple-200 dark:border-purple-800">
        <p className="text-sm font-semibold text-purple-800 dark:text-purple-200 flex items-center">
          <Moon className="w-4 h-4 mr-2 float-animation" style={{animationDuration: '2s'}} />
          June 25-26: New Moon - Perfect for stargazing!
        </p>
        <p className="text-xs text-purple-700 dark:text-purple-300 mt-1">
          Darkest nights of your trip with minimal moon interference
        </p>
      </div>
    </div>
  );
};

MoonPhaseCalendar.propTypes = {
  moonData: PropTypes.shape({
    week: PropTypes.arrayOf(PropTypes.shape({
      date: PropTypes.instanceOf(Date),
      phase: PropTypes.shape({
        emoji: PropTypes.string,
        name: PropTypes.string,
        illumination: PropTypes.number
      }),
      moonrise: PropTypes.string,
      moonset: PropTypes.string
    }))
  })
};

export default memo(MoonPhaseCalendar);